( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;

      if ( $( window ).width() > 1024 ) {
        // ADA close menu when focus shifts outside of it
        $( '.navigation-five .primary-navigation__panels' ).on( 'focusout', function( e ) {
          const $menuItem = $( this );
          const newFocus = e.relatedTarget;
          if ( newFocus === null ) return;
          if ( !$menuItem.has( newFocus ).length ) {
            const $trigger = $menuItem.find( '.primary-menu-item__link.is-open' );
            if ( $trigger.length ) {
              $trigger.trigger( 'click' );
              newFocus.focus();
            }
          }
        } );
      }

      $( '.navigation-five .navbar-toggle, .navigation-five .primary-menu-item__link, .navigation-five .primary-menu-item__back, .navigation-five .easy-toggle-slide-toggle' ).on( 'toggleAfter toggleBefore', function() {
        window.requestAnimationFrame( () => {
          _this.updateMobileNavigationHeight();
        } );
        window.setTimeout( () => {
          _this.updateMobileNavigationHeight();
        }, 450 );
      } );

      $( '.navigation-five .primary-menu-item__menu .easy-toggle-slide-toggle' ).on( 'click', function( event ) {
        event.stopPropagation();
      } );

      $( window ).on( 'resize', function() {
        _this.updateMobileNavigationHeight();
      } );

      $( '.navigation-five img' ).on( 'load', function() {
        _this.updateMobileNavigationHeight();
      } );

      this.updateMobileNavigationHeight();
    },
    finalize: function() {
    },
    updateMobileNavigationHeight: function() {
      if ( window.matchMedia( '(min-width: 1024px)' ).matches ) {
        $( '.navigation-five .js-mobile-nav-scroll' ).css( '--navigationDropdownCtaHeight', '' );
        $( '.navigation-five .primary-nav' ).removeClass( 'has-child-menu-open' );
        return;
      }

      const ctaHeight = $( '.navigation-five .primary-nav > ul.fixed' ).outerHeight() || 0;
      const $primaryNav = $( '.navigation-five .primary-nav' );
      const childMenuIsOpen = $( '.navigation-five .primary-menu-item__menu.is-open:visible' ).length > 0;

      $primaryNav.toggleClass( 'has-child-menu-open', childMenuIsOpen );

      if ( childMenuIsOpen ) {
        $primaryNav.scrollTop( 0 );
      }

      $( '.navigation-five .js-mobile-nav-scroll' ).each( function() {
        this.style.setProperty( '--navigationDropdownCtaHeight', `${ctaHeight}px` );
      } );
    },
  };

  app.registerComponent( 'navigation-five', COMPONENT );
} )( app );
